import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface EmailData {
  to: string;
  subject: string;
  template: string;
  data: {
    clientName?: string;
    mentorName?: string;
    sessionDate?: string;
    sessionTime?: string;
    amount?: number;
    currency?: string;
    transactionId?: string;
    [key: string]: any;
  };
}

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private apiUrl = `${environment.apiUrl}/email`;

  constructor(private http: HttpClient) {}

  /**
   * Envía un correo de notificación de compra exitosa
   */
  sendPurchaseNotification(emailData: EmailData): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-purchase-notification`, emailData);
  }

  /**
   * Envía un correo de confirmación de cita
   */
  sendAppointmentConfirmation(emailData: EmailData): Observable<any> {
    return this.http.post(`${this.apiUrl}/send-appointment-confirmation`, emailData);
  }

  /**
   * Envía un correo genérico
   */
  sendEmail(emailData: EmailData): Observable<any> {
    return this.http.post(`${this.apiUrl}/send`, emailData);
  }
}
